import { Layout, Avatar, Typography, Space, Popover } from 'antd'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from '@ant-design/icons'
import './index.css'
import ProjectSelector from './components/ProjectSelector'
import { CIMSTags } from 'components/CIMSTags'
import { useAuthContext } from 'context/AuthContext'
import { useGlobalState } from 'context/GlobalStateContext'
import { CIMSTag } from 'components/CIMSTag'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'

export interface NavHeaderProps {
  collapsed: boolean
  setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}

export const NavHeader: React.FC<NavHeaderProps> = ({
  collapsed: c,
  setCollapsed,
}) => {
  const { user } = useAuthContext()
  const {
    state: { projectGlobalId },
  } = useGlobalState()

  const roles = new Map<string, { name: string; color?: 'purple' }>()
  user?.projects
    .find(({ id }) => projectGlobalId === id)
    ?.roles.map((role) => role)
    ?.forEach(({ id, name }) => roles.set(id, { name }))
  if (user?.developer === true)
    roles.set('developer', { name: 'Developer', color: 'purple' })
  else if (user?.admin(projectGlobalId).authorized)
    roles.set('admin', { name: 'Project Admin', color: 'purple' })
  const values = [...roles.values()]

  const menu: Pick<AntdIconProps, 'onClick' | 'className'> = {
    onClick: () => setCollapsed((prevState) => !prevState),
    className: 'menu-toggle',
  }

  return (
    <Layout.Header
      style={{
        background: '#fff',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '16px 32px',
        minHeight: '10vh',
        gap: 16,
        lineHeight: 'normal',
      }}
    >
      {c ? <MenuUnfoldOutlined {...menu} /> : <MenuFoldOutlined {...menu} />}
      {user && (
        <>
          <ProjectSelector />
          <Space size="small" align="center" direction="vertical">
            <Typography.Text id="cims-display-name">
              {user.username}
            </Typography.Text>
            {!!values.length && (
              <Popover
                content={
                  roles.size > 1 ? (
                    <CIMSTags
                      direction={{ tags: 'vertical' }}
                      tags={values
                        .slice(1)
                        .map(({ name, color }) => ({ color, text: name }))}
                    />
                  ) : undefined
                }
                trigger="click"
                placement="bottom"
              >
                <CIMSTag
                  color={values[0].color}
                  style={{ cursor: values.length > 1 ? 'pointer' : undefined }}
                >
                  {`${values[0].name}${
                    values.length > 1 ? ` (+${values.length - 1})` : ''
                  }`}
                </CIMSTag>
              </Popover>
            )}
          </Space>
          <Avatar
            style={{ backgroundColor: '#001529' }}
            icon={<UserOutlined />}
          />
        </>
      )}
    </Layout.Header>
  )
}
